import { StatusPill as SharedStatusPill } from "../../../StatusPill"
import type { IProps } from "./interfaces"

/**
 * Re-export of the shared `StatusPill` so the existing local import path
 * keeps working. The actual implementation lives in `components/StatusPill/`
 * — both home (meeting list) and detail use that single component, after
 * the 2026-05-14 audit flagged two divergent implementations.
 */
export function StatusPill({ phase }: IProps): React.JSX.Element {
  return <SharedStatusPill phase={phase} />
}
